export default __webpack_public_path__ + "static/media/video-thumb .b4f22b2b.jpg";